import $ from "jquery";

const cardBalanceWidget = () => {
  // --------- Change this to appropriate URL when deploying -----------
  // const apiUrl = "https://testmetrocardapi.ecan.govt.nz/Account/customerBalance/";
  // const apiUrl = "https://metrocardapi.ecan.govt.nz/Account/customerBalance/";
  const apiUrl = "/api/balance";
  const loginUrl = "https://metrocard.metroinfo.co.nz/#/login";
  const registerUrl = "https://metrocard.metroinfo.co.nz/#/registration";
  const orderCardUrl = "https://metrocard.metroinfo.co.nz/#/orderCard";
  //-------------------------------------------------------------------

  const $metrocardno = $("#metrocardno");
  const $cardBalance = $("#cardBalance");
  const $pendingAmount = $("#pendingAmount");
  const $busyDiv = $("#cardBalanceBusy");
  const $spinner = $("#cardBalanceSpinner");
  const $inputserrorMessage = $("#inputserrorMessage");
  const $balanceerrorMessage = $("#balanceerrorMessage");
  const $metrocardnoforbalance = $("#metrocardnoforbalance");
  const $inputs = $("#inputs");
  const $balance = $("#balance");
  const $balanceok = $("#balanceok");
  const $balanceerror = $("#balanceerror");
  const $checkanothercard = $("#checkanothercard");

  const showSpinner = () => {
    $spinner.addClass("spinner");
    $busyDiv.show();
  };

  const hideSpinner = () => {
    $spinner.removeClass("spinner");
    $busyDiv.hide();
  };

  const hideAllElements = () => {
    $balance.hide();
    hideSpinner();
  };

  const fadeOutErrorMessage = () => {
    $inputserrorMessage.css("filter", "alpha(opacity=40)");
    $inputserrorMessage.fadeOut(500);
    $inputserrorMessage.html("");
  };

  const displayMetrocardErrorMessage = errorMsg => {
    $inputserrorMessage.html(errorMsg);
    $inputserrorMessage.css("filter", "alpha(opacity=40)");
    $inputserrorMessage.fadeIn(500);
    setTimeout(fadeOutErrorMessage, 4000);
  };

  const getBalance = (cardNumber, recaptchaToken) => {
    showSpinner();
    $balanceok.hide();
    $balanceerror.hide();

    const data = {
      cardNumber,
      recaptchaToken
    };

    $.post(apiUrl, data)
      .done(response => {
        if (response) {
          $metrocardno.html(cardNumber);
          $cardBalance.html(`$${response.balance.toFixed(2)}`);
          $pendingAmount.html(
            `Pending amount: $${response.pendingTopupAmount.toFixed(2)}`
          );
          $balanceok.show();
        } else {
          $balanceerrorMessage.html(response.errorMessage);
        }
      })
      .fail(error => {
        $balanceok.hide();
        $balanceerror.show();
        switch (error.status) {
          case 200:
            $balanceerrorMessage.html(
              "Sorry, we couldn't find that card. Please check the number and try again."
            );
            break;
          default:
            $balanceerrorMessage.html(
              "Oops, something isn't quite working. Please check your internet connection and try again in a few moments."
            );
        }
      })
      .always(() => {
        $balance.show();
        $inputs.hide();
        $checkanothercard.show();
        hideSpinner();
      });
  };

  // Show our input fields
  $inputs.show();
  // Hide all elements
  hideAllElements();

  // Bind event listeners
  $("#showbalance").click(() => {
    /* eslint-disable-next-line */
    const recaptchaToken = grecaptcha.getResponse();
    const cardNumber = $metrocardnoforbalance.val();

    if (Number.isNaN(Number(cardNumber)) || !cardNumber || cardNumber < 0) {
      displayMetrocardErrorMessage("Invalid Metrocard number");
      return false;
    }

    if (!recaptchaToken) {
      displayMetrocardErrorMessage(
        'Please tick the "Recaptcha" box to continue'
      );
      return false;
    }

    $inputserrorMessage.html("");
    getBalance(cardNumber, recaptchaToken);
    return false;
  });

  $("#login").click(() => {
    window.open(loginUrl, "_blank");
    return false;
  });

  $("#ordercard").click(() => {
    window.open(orderCardUrl, "_blank");
    return false;
  });

  $("#register").click(() => {
    window.location.href = registerUrl;
    return false;
  });

  $checkanothercard.click(() => {
    $inputs.show();
    $balance.hide();
    grecaptcha.reset(); // eslint-disable-line
    $inputserrorMessage.html("");
    $balanceerrorMessage.html("");
    return false;
  });
};

export default cardBalanceWidget;
